<script setup lang="ts">
import {ref} from "vue";
import {getCsrfParam, getCsrfToken} from "../ts/utils";

const props = defineProps<{
  id: number;
  url: string;
  formName: string;
}>()

const logoUrl = ref<string>(props.url || "/no-image.png")
const logoId = ref<number>(props.id)
const fileInput = ref(null)

function removeLogo() {
  logoId.value = 0
  logoUrl.value = ""
}

function fileChange() {
  const promiseList = []
  for (const i in fileInput.value.files) {
    const form = new FormData()
    form.append('file', fileInput.value.files[i])
    form.append(getCsrfParam(), getCsrfToken())
    const p = fetch('/site/upload', {method: 'POST', body: form})
        .then(r => r.json())
        .then(r => {
          if (r.success) {
            logoUrl.value = r.model.url
            logoId.value = r.model.id
            return r.model
          }
        }).catch(() => removeLogo())
    promiseList.push(p)
  }

  Promise.all(promiseList)
      .finally(() => fileInput.value.value = null)
}
</script>

<template>

  <div>
    <input accept="image/*" ref="fileInput" @change="fileChange()" class="hidden" type="file">
    <input :name="formName +'[logo_id]'" type="hidden" :value="logoId">
    <button
        type="button"
        class="flex min-h-32 w-full items-center justify-center rounded-lg border border-dashed border-slate-300 bg-slate-50 p-4 text-sm text-slate-600 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        :aria-label="logoId ? 'Изменить логотип' : 'Загрузить логотип'"
        @click="fileInput.click()"
    >
      <img v-if="logoId" :src="logoUrl" alt="" height="128" class="max-h-32 max-w-full rounded border border-slate-200 object-contain">
      <span v-else>Нажмите, чтобы выбрать логотип</span>
    </button>
    <div class="mt-3 flex flex-wrap gap-2">
      <button type="button" class="app-button app-button-danger" @click="removeLogo()">Удалить</button>
    </div>
  </div>
</template>

<style scoped>

</style>
